import type { AdminSetRoleResponse, AdminUsersListResponse, Role } from '../../api/types';
import type { AdminRepository } from '../../repositories/ApiAdminRepository';

export class AdminService {
  constructor(private readonly repo: AdminRepository) {}

  listUsers(params: { query?: string; limit?: number; offset?: number }): Promise<AdminUsersListResponse> {
    return this.repo.listUsers(params);
  }

  setUserRole(params: { telegramId: string; role: Role }): Promise<AdminSetRoleResponse> {
    return this.repo.setUserRole(params);
  }
}
